// extracted by mini-css-extract-plugin
export default {"wraper":"ChangePassword_wraper__uJSqx","box":"ChangePassword_box__t9M3R"};